







































import { Component, Mixins, Vue } from 'vue-property-decorator'
import {AppConfig} from '@/config/app.config'
import * as Helper from '@/helpers'
import {$, PageCollection} from 'simpli-web-sdk'
import { MixinFilter } from '@/components/mixins/MixinFilter'
import moment from 'moment'
import ClientNotificationRequest from '@/model/request/ClientNotificationRequest'
import ClientNotificationResponse from '@/model/response/ClientNotificationResponse'
import FilterClientNotification from '@/components/filters/FilterClientNotification.vue'
import FilterToggle from '@/components/FilterToggle.vue'
import ClientNotificationResponseCSV from '@/model/response/ClientNotificationResponseCSV'
const metaInfo = () => ({
  title: $.t('view.reports.clientNotification.title'),
})
@Component({
  components: { FilterClientNotification, FilterToggle },
  metaInfo})
export default class ReportsClientNotificationView extends Mixins(MixinFilter) {
  filter = new ClientNotificationRequest()
  collection = new PageCollection(ClientNotificationResponse, this.filter, 10)
  AppConfig = AppConfig

  created() {
    this.filter.startDate = moment().format()
  }

  async downloadData(xlsx: boolean) {
    if (!xlsx) {
      const csv = new PageCollection(ClientNotificationResponseCSV, this.filter, null, null)
      const fetch = async () => await csv.search()
      await $.await.run(fetch, 'download')
      csv.downloadCsv($.t('classes.ClientNotificationResponseCSV.title'))
    } else {
      await $.await.run(() => Helper.downloadXlsx(
        $.t('classes.ClientNotificationResponseCSV.title'),
        new ClientNotificationResponseCSV().$endpoint,
        this.filter,
        ClientNotificationResponseCSV,
        'ClientNotificationResponseCSV',
      ), 'download')
    }
  }
}
